import {
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  GET_PASSWORD_SUCCESSFUL,
  GET_PASSWORD_FAILED,
  CREATE_NEW_USER_SUCCESSFUL,
  CREATE_NEW_USER_FAILED,
} from "./actionTypes"

const initialState = {
  registrationError: null,
  userInfo: null,
  sessionId: null,
  newUserCreated: false,
  password: null,
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER_SUCCESSFUL:
      state = {
        ...state,
        userInfo: action.payload,
	sessionId: action.payload.sessionId,
        registrationError: null,
      }
      break
    case REGISTER_USER_FAILED:
      state = {
        ...state,
        registrationError: action.payload,
      }
      break
    case CREATE_NEW_USER_SUCCESSFUL:
      state = {
        ...state,
        newUserCreated: true,
      }
      break
    case CREATE_NEW_USER_FAILED:
      state = {
        ...state,
        newUserCreated: false,
	registrationError: action.payload,
      }
      break

    case GET_PASSWORD_SUCCESSFUL:
      state = {
        ...state,
        password: action.payload,
      }
      break
    case GET_PASSWORD_FAILED:
      state = {
        ...state,
        registrationError: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default account
